import { apiFetch } from 'services/apiClient';
import { Page } from '../../../types/Page';
import { Leave } from '../types/Leave';

export const listLeaves = (page = 0, size = 10, sort?: string, query?: string): Promise<Page<Leave>> =>
  apiFetch('/leaves?page=' + page + '&size=' + size + (sort ? '&sort=' + sort : '') + (query ? '&' + query : ''));
export const listLeavesAll = (query?: string): Promise<Leave[]> =>
  apiFetch('/leaves/all' + (query ? `?${query}` : ''));
export const listMyLeavesAll = (query?: string): Promise<Leave[]> =>
  apiFetch('/leaves/me/all' + (query ? `?${query}` : ''));
export const getLeave = (id: number): Promise<Leave> => apiFetch('/leaves/' + id);
export const createLeave = (data: any): Promise<Leave> =>
  apiFetch('/leaves', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const updateLeave = (id: number, data: any): Promise<Leave> =>
  apiFetch('/leaves/' + id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const deleteLeave = (id: number): Promise<void> =>
  apiFetch('/leaves/' + id, { method: 'DELETE' });
